<template>
    <div>
        <div class="pop-region" @touchmove.prevent>
            <div class="region-wrapper">
                <section id="common" class="ui-tabs ui-region">
                    <ul class="ui-tabs-menu ui-cols3 clearfix" data-tabs="tabs">
                        <li v-for="tab in options.regionTabs" :key="tab.id" :class="{ cur: currentTab.id === tab.id }" @click="toggleTab(tab)">
                            {{ tab.name }}
                        </li>
                    </ul>
                </section>
                <keep-alive>
                    <china-area
                        v-if="currentTab.id === 'chinaArea'"
                        :hotCities="hotCities"
                        :provinceList="provinceList"
                        :cityList="cityList"
                        :countyList="countyList"
                        :fromAddrObj="fromAddrObj"
                        @changeData="getRegions"
                        @receiveData="receiveData"
                    />
                    <hmt-area
                        v-if="currentTab.id === 'hmtArea'"
                        :hmtList="hmtList"
                        :hmtAreaList="hmtAreaList"
                        :hmtCountyList="hmtCountyList"
                        :fromAddrObj="fromAddrObj"
                        @changeData="getRegions"
                        @receiveData="receiveData"
                    />
                    <inter-area
                        v-if="currentTab.id === 'interArea'"
                        :internationalList="internationalList"
                        :fromAddrObj="fromAddrObj"
                        @receiveData="receiveData"
                    />
                </keep-alive>
            </div>
            <div class="primary-btn" :class="disabledBtn ? 'disable' : ''" @click="!disabledBtn && confirmRegion()">{{ _ll('确认') }}</div>
            <div class="primary-btn white" @click="cancelRegion">{{ _ll('取消') }}</div>
        </div>
        <div v-show="isMaskShow" id="mask-layer" class="fixed-100"></div>
    </div>
</template>

<script>
import ajax from '../../api/ajax'
import { RegionGroup } from '../../constant/common'
import ChinaArea from './china-area'
import HMTArea from './hmt-area'
import InterArea from './inter-area'
import { COUNTRY_CODE } from '@uip-alpha/business-constants'

export default {
    name: 'Region',
    components: {
        'china-area': ChinaArea,
        'hmt-area': HMTArea,
        'inter-area': InterArea
    },
    props: {
        options: {
            source: {
                type: String,
                defaultValue: ''
            },
            isOrigin: {
                type: Boolean,
                defaultValue: true
            },
            selectOriginAreaCode: {
                type: String,
                defaultValue: ''
            },
            regionTabs: {
                type: Array,
                defaultValue: []
            }
        }
    },
    data() {
        return {
            currentTab: { id: 'chinaArea', name: this._ll('中国大陆') },
            areaSelectCode: {
                mainLandCode: COUNTRY_CODE.MAINLAND,
                internationalCode: 'A000000000'
            },
            serverNetworkError: false,
            dataNotFound: false,
            hotCities: [],
            provinceList: [],
            cityList: [],
            countyList: [],
            hmtList: [],
            hmtAreaList: [],
            hmtCountyList: [],
            internationalList: [],
            toAddrObj: {
                selectCode: '',
                selectName: '',
                selectLevel: '',
                selectCityCode: '',
                selectProvinceCode: ''
            },
            fromAddrObj: {
                selectCode: '',
                selectName: '',
                selectLevel: '',
                selectCityCode: '',
                selectProvinceCode: ''
            },
            disabledBtn: true,
            isMaskShow: false
        }
    },
    created: function () {
        const that = this
        that.isMaskShow = true
        if (that.options.source === 'range') {
            that.currentTab = that.options.regionTabs.find(value => value.id === that.$store.state.range.currentTabId)
            that.fromAddrObj.selectCode = that.$store.state.range.areaCode || ''
            that.fromAddrObj.selectCityCode = that.$store.state.range.selectCityCode || ''
            that.fromAddrObj.selectProvinceCode = that.$store.state.range.selectProvinceCode || ''
        }
        if (that.options.source === 'payFee') {
            if (that.options.isOrigin) {
                that.currentTab = that.options.regionTabs.find(value => value.id === that.$store.state.payFee.selectOriginCurrentTabId)
                that.fromAddrObj.selectCode = that.$store.state.payFee.selectOriginAreaCode || ''
                that.fromAddrObj.selectCityCode = that.$store.state.payFee.selectOriginCityCode || ''
                that.fromAddrObj.selectProvinceCode = that.$store.state.payFee.selectOriginProvinceCode || ''
            } else {
                that.currentTab = that.options.regionTabs.find(value => value.id === that.$store.state.payFee.selectDestCurrentTabId)
                that.fromAddrObj.selectCode = that.$store.state.payFee.selectDestAreaCode || ''
                that.fromAddrObj.selectCityCode = that.$store.state.payFee.selectDestCityCode || ''
                that.fromAddrObj.selectProvinceCode = that.$store.state.payFee.selectDestProvinceCode || ''
            }
        }
        if (that.fromAddrObj.selectProvinceCode === 'NODATA') {
            that.fromAddrObj.selectProvinceCode = that.selectCityCode
            that.fromAddrObj.selectCityCode = that.fromAddrObj.selectCode
            that.fromAddrObj.selectCode = 'NODATA'
        }
        if (that.currentTab.id === 'chinaArea') {
            that.getPopularRegions()
            that.getRegions(that.areaSelectCode.mainLandCode, 1)
        }
        if (that.currentTab.id === 'hmtArea') {
            that.getRegions(that.areaSelectCode.internationalCode, 1)
        }
        if (that.currentTab.id === 'interArea') {
            that.getRegions(that.areaSelectCode.internationalCode, 1)
        }
    },
    methods: {
        toggleTab: function (tab) {
            const that = this
            that.currentTab = tab
            if (that.currentTab.id === 'chinaArea') {
                if (that.hotCities.length === 0) {
                    this.getPopularRegions()
                }
                if (that.provinceList.length === 0) {
                    that.getRegions(that.areaSelectCode.mainLandCode, 1)
                }
            }
            if (that.currentTab.id === 'hmtArea') {
                if (that.hmtList.length === 0) {
                    that.getRegions(that.areaSelectCode.internationalCode, 1)
                }
            }
            if (that.currentTab.id === 'interArea') {
                if (that.internationalList.length === 0) {
                    that.getRegions(that.areaSelectCode.internationalCode, 1)
                }
            }
        },
        /**
         * 查询下级行政区划数据
         * @param code 父级code
         * @param parentLevel 父级level
         */
        getRegions: function (code, parentLevel) {
            const that = this
            if (that.currentTab.id === 'chinaArea') {
                if (code === 'PROVINCE') {
                    that.cityList.splice(0, that.cityList.length, { name: this._ll('请选择'), code: 'CITY', level: 3, parentCode: '' })
                    that.countyList.splice(0, that.countyList.length, { name: this._ll('请选择'), code: 'COUNTY', level: 4, parentCode: '' })
                    return
                }
                if (code === 'CITY') {
                    that.countyList.splice(0, that.countyList.length, { name: this._ll('请选择'), code: 'COUNTY', level: 4, parentCode: '' })
                    return
                }
            }
            if (that.currentTab.id === 'hmtArea') {
                if (code === 'HMT') {
                    that.hmtAreaList.splice(0, that.hmtAreaList.length, { name: this._ll('请选择'), code: 'HMTAREA', level: 4, parentCode: '' })
                    return
                }
                if (code === 'HMTAREA') {
                    that.hmtCountyList.splice(0, that.hmtCountyList.length, { name: this._ll('请选择'), code: 'HMTCOUNTY', level: 5, parentCode: '' })
                    return
                }
            }
            let param, regionRequest
            if (RegionGroup.HMTArray.findIndex(value => value === code) > -1) {
                regionRequest = ajax.getRegions
                param = { level: 2, code }
            } else {
                regionRequest = ajax.getRegions
                param = { code }
            }
            if (that.currentTab.id === 'interArea') {
                if (that.options.source === 'range' || that.options.isOrigin) {
                    regionRequest = ajax.getOriginRegions
                    param = { level: -1, code }
                } else if (!that.options.isOrigin) {
                    regionRequest = ajax.getDestRegions
                    param = { originCode: that.options.selectOriginAreaCode, level: -1 }
                }
            }

            regionRequest({
                params: param
            })
                .then(response => {
                    if (that.currentTab.id === 'chinaArea') {
                        if (parentLevel === 1) {
                            that.provinceList.splice(0, that.provinceList.length, {
                                name: this._ll('请选择'),
                                code: 'PROVINCE',
                                level: 2,
                                parentCode: ''
                            })
                        }
                        if (parentLevel === 2) {
                            that.cityList.splice(0, that.cityList.length, { name: this._ll('请选择'), code: 'CITY', level: 3, parentCode: '' })
                        }
                        if (parentLevel === 3) {
                            that.countyList.splice(0, that.countyList.length, { name: this._ll('请选择'), code: 'COUNTY', level: 4, parentCode: '' })
                        }
                    }
                    if (that.currentTab.id === 'hmtArea') {
                        if (parentLevel === 1) {
                            that.hmtList.splice(0, that.hmtList.length, { name: this._ll('请选择'), code: 'HMT', level: 2, parentCode: '' })
                        }
                        if (parentLevel === 2) {
                            that.hmtAreaList.splice(0, that.hmtAreaList.length, {
                                name: this._ll('请选择'),
                                code: 'HMTAREA',
                                level: 4,
                                parentCode: ''
                            })
                        }
                        if (parentLevel === 4) {
                            that.hmtCountyList.splice(0, that.hmtCountyList.length, {
                                name: this._ll('请选择'),
                                code: 'HMTCOUNTY',
                                level: 5,
                                parentCode: ''
                            })
                        }
                    }
                    if (response.data.length === 0 && RegionGroup.MACAOArea.find(value => value === code)) {
                        that.hmtCountyList.splice(0, that.hmtCountyList.length, {
                            name: this._ll('暂不选择'),
                            code: 'NODATA',
                            level: 5,
                            parentCode: ''
                        })
                    } else {
                        for (let key = 0; key < response.data.length; key++) {
                            const regionData = response.data[key]
                            // 屏蔽"中国"
                            if (regionData.code === COUNTRY_CODE.MAINLAND) {
                                continue
                            }
                            if (that.currentTab.id === 'chinaArea') {
                                if (!regionData.availableAsOrigin && !regionData.availableAsDestination) {
                                    continue
                                }
                                if (parentLevel === 1 && regionData.level === 2) {
                                    // 省/直辖市
                                    that.provinceList.push(regionData)
                                }
                                if (parentLevel === 2 && regionData.level === 3) {
                                    // 市
                                    that.cityList.push(regionData)
                                }
                                if (parentLevel === 3 && regionData.level === 4) {
                                    // 区/县/镇
                                    that.countyList.push(regionData)
                                }
                            }
                            if (that.currentTab.id === 'hmtArea') {
                                if (!regionData.availableAsOrigin && !regionData.availableAsDestination) {
                                    continue
                                }
                                if (parentLevel === 1 && regionData.level === 2) {
                                    that.hmtList.push(regionData)
                                }
                                if (parentLevel === 2 && regionData.level === 4) {
                                    that.hmtAreaList.push(regionData)
                                }
                                if (parentLevel === 4 && regionData.level === 5) {
                                    that.hmtCountyList.push(regionData)
                                }
                            }
                            if (that.currentTab.id === 'interArea' && parentLevel === regionData.level) {
                                that.internationalList.push(regionData)
                            }
                        }
                    }
                })
                .catch(response => {
                    if (response.status === 404 || response.status === 403 || response.status === 0) {
                        this.$toast(this._ll('对不起，查询不到数据'))
                    } else {
                        this.$toast(this._ll('服务器暂不可用，请稍后再试'))
                    }
                })
        },
        /**
         * 查询热门城市数据
         */
        getPopularRegions: function () {
            const that = this
            ajax.getPopularRegions()
                .then(response => {
                    let arr = []
                    if (response.data.length > 9) {
                        arr = response.data.slice(0, 9)
                    } else if (response.data.length === 0) {
                        that.$toast(this._ll('对不起，查询不到数据'))
                    } else {
                        arr = response.data
                    }
                    for (let key = 0; key < arr.length; key++) {
                        const regionData = arr[key]
                        if (regionData.code === 'A310000000') {
                            // 上海
                            regionData.code = 'A311000000' // 上海市
                        }
                        if (regionData.code === 'A110000000') {
                            // 北京
                            regionData.code = 'A111000000'
                        }
                        that.hotCities.push({
                            name: regionData.name,
                            code: regionData.code,
                            level: regionData.level,
                            parentCode: regionData.provinceCode
                        })
                    }
                })
                .catch(response => {
                    if (response.status === 404 || response.status === 403 || response.status === 0) {
                        this.$toast(this._ll('对不起，查询不到数据'))
                    } else {
                        that.serverNetworkError = true
                        this.$toast(this._ll('服务器暂不可用，请稍后再试'))
                    }
                })
        },
        /**
         * 接收子组件传来的已选择的数据
         * @param city
         * @param county
         * @param disabledFlg
         */
        receiveData: function (province, city, county, disabledFlg) {
            if (this.currentTab.id === 'chinaArea') {
                if (county && city && province) {
                    this.toAddrObj.selectCode = county.code
                    this.toAddrObj.selectName = `${city.name}-${county.name}`
                    this.toAddrObj.selectLevel = county.level
                    this.toAddrObj.selectCityCode = city.code
                    this.toAddrObj.selectProvinceCode = province.code
                }
            }
            if (this.currentTab.id === 'hmtArea') {
                if (county && city && province) {
                    this.toAddrObj.selectCode = county.code
                    this.toAddrObj.selectName =
                        county.code === 'NODATA' ? `${province.name}-${city.name}` : `${province.name}-${city.name}-${county.name}`
                    this.toAddrObj.selectLevel = county.level
                    this.toAddrObj.selectCityCode = city.code
                    this.toAddrObj.selectProvinceCode = province.code
                }
            }
            if (this.currentTab.id === 'interArea' && province) {
                this.toAddrObj.selectCode = province.code
                this.toAddrObj.selectName = province.name
                this.toAddrObj.selectLevel = province.level
                this.toAddrObj.selectCityCode = ''
                this.toAddrObj.selectProvinceCode = ''
            }
            this.disabledBtn = disabledFlg
        },
        confirmRegion: function () {
            // 收送范围查询
            if (this.options.source === 'range') {
                this.$emit('selectRegion', {
                    currentTabId: this.currentTab.id,
                    name: this.toAddrObj.selectName,
                    level: this.toAddrObj.selectLevel,
                    code: this.toAddrObj.selectCode,
                    selectCityCode: this.toAddrObj.selectCityCode,
                    selectProvinceCode: this.toAddrObj.selectProvinceCode
                })
            }
            // 运费时效查询
            if (this.options.source === 'payFee') {
                this.$emit('selectRegion', {
                    isOrigin: this.options.isOrigin,
                    currentTabId: this.currentTab.id,
                    selectName: this.toAddrObj.selectName,
                    selectCode: this.toAddrObj.selectCode,
                    selectCityCode: this.toAddrObj.selectCityCode,
                    selectProvinceCode: this.toAddrObj.selectProvinceCode
                })
            }
            this.$emit('regionShow', false, this.options.isOrigin)
        },
        cancelRegion: function () {
            this.$emit('regionShow', false, this.options.isOrigin)
        }
    }
}
</script>

<style lang="scss" scoped>
.pop-region {
    position: fixed;
    z-index: 999;
    bottom: 0;
    width: 100%;
    max-width: $max-width;
    min-width: $min-width;
    overflow: hidden;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.8);
    color: $white;
}
.ui-tabs-menu li.cur {
    color: $white;
    position: relative;
}
.ui-tabs-menu li.cur:after {
    position: absolute;
    display: inline-block;
    content: '';
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
    border-bottom: 15px solid $white;
    bottom: 0;
    left: calc(50% - 7.5px);
}
.ui-tabs-menu li {
    float: left;
    height: 100px;
    line-height: 100px;
    text-align: center;
}
.ui-cols3 li {
    width: 33.333333333%;
}
#mask-layer {
    z-index: 900;
}
.primary-btn {
    margin: 30px 0 30px 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/region/index.vue